
import debounce from 'lodash.debounce'

export default {
  name: 'MegaMenuWrap',
  props: ['parent', 'level', 'menu'],
  data() {
    return {
      list: [],
      activeId: null,
    }
  },
  created() {
    const delay = 200
    this.debounceGetCategories = debounce((parent, level, title) => {
      this.getCategories(parent, level, title)
    }, delay)
  },
  methods: {
    async getCategories(parent, level, title) {
      if (this.menu && this.menu.has(parent)) {
        this.list = this.menu.get(parent)
      }
      this.activeId = parent
      this.$emit('update', 0, this.list, level, parent)
      this.$emit('update-title', title)
    },
  },
  render() {
    return this.$scopedSlots.default({
      get: (parent, level, title) => this.debounceGetCategories(parent, level, title),
      active_id: this.activeId,
    })
  },
}
